// extracted by mini-css-extract-plugin
export default {"placeholderBody":"PlaceholderTile_placeholderBody__PWbPP","rowOne":"PlaceholderTile_rowOne__b6Iwj","rowTwo":"PlaceholderTile_rowTwo__yWvJB"};